<template>
  <LoginComponent :placeholder="'0123456789123'" :mode="'numeric'"
                  :test-pins="['2102970103257', '1507987175029']"
                  :initial-pin="pin"/>
</template>

<script>
import LoginComponent from '@shared/components/LoginComponent'

export default {
  name: 'LoginPage',
  components: { LoginComponent },
  props: ['pin']
}
</script>
